import { stage, trackWithDefaultStage } from "@flights/et-universal";
import { isOfMetaOrigin, isOfPPCOrigin } from "../utils/marketing-url-params.js";
import usePointOfSale from "./usePointOfSale.js";
import useUserAgent from "./useUserAgent.js";
import useRouteName from "./useRouteName.js";
const SUMMER_DEAL_2026_POS = new Set([
    "at",
    "be",
    "bh",
    "ca",
    "ch",
    "cy",
    "cz",
    "de",
    "dk",
    "ee",
    "es",
    "fi",
    "fr",
    "gr",
    "hk",
    "hu",
    "ie",
    "is",
    "it",
    "jp",
    "lu",
    "mt",
    "mx",
    "nl",
    "no",
    "om",
    "ph",
    "pl",
    "pt",
    "ro",
    "rs",
    "se",
    "th",
    "us",
    "sg"
]);
export const useSummerDeal = () => {
    const pointOfSale = usePointOfSale();
    const { isMobile } = useUserAgent();
    const routeName = useRouteName();
    const isSummerDealEligible = SUMMER_DEAL_2026_POS.has(pointOfSale?.toLowerCase() ?? "") && !isOfMetaOrigin() && !isOfPPCOrigin();
    const isSummerDealExp = isSummerDealEligible && !!trackWithDefaultStage("flights_web_cat_summer_deal_2026", 1);
    if (isSummerDealEligible) {
        stage("flights_web_cat_summer_deal_2026", isMobile ? 3 : 2);
        if (routeName === "fly-anywhere") {
            stage("flights_web_cat_summer_deal_2026", 4);
        }
    }
    return { isSummerDealEligible, isSummerDealExp };
};
